import styled, { css } from 'styled-components';

import card from 'styles/components/card';
import { COLOR_GRAY_60 } from 'styles/variables/colors';

export const Card = styled.div`
  ${card};
  margin: 0 0 40px 0;
  padding: 40px;
`;

export const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
`;

export const Title = styled.h3`
  display: inline-flex;
  font-size: 1.5rem;
  font-weight: 800;
  margin: 0 0 10px 0;

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const Separator = styled.div`
  border-top: 1px solid #eee;
`;

export const PlanFieldContainer = styled.div`
  margin: ${(props) => props.margin || '20px 0 35px 0'};
`;

export const BillingInterval = styled.p`
  font-size: 0.875rem;
  margin: 0;
  color: ${COLOR_GRAY_60};
`;

export const AmountContainer = styled.div`
  margin-bottom: 32px;
  display: flex;
  flex-direction: column;

  & > div:first-of-type {
    margin-bottom: 32px;
  }
`;

export const AmountGrid = styled.div`
  display: inline-flex;
  align-items: center;

  &:first-of-type {
    margin-right: 63px;
  }
`;

export const AmountIcon = styled.div`
  margin-right: 16px;
`;

export const AmountContent = styled.div``;

export const AmountLabel = styled.p`
  margin: 0 0 10px 0;
  font-size: 0.875rem;
  font-weight: bold;
`;

export const AmountValue = styled.p`
  margin: 0;
  font-size: 1rem;
`;

export const ChangeButtonContainer = styled.div`
  width: 180px;
  display: inline-block;
  margin-right: 30px;
`;
